import { LangDic, LangGroupedDic, LanguageName } from ".";

export const allStrings: LangDic = {};

export const allGroupedStrings: LangGroupedDic = {};

export const languageNames: LanguageName[] = [
  { key: "DE", name: "Deutsch" },
  { key: "EN", name: "English" },
  { key: "ES", name: "Español" },
  { key: "FR", name: "Français" },
  { key: "IT", name: "Italiano" },
  { key: "PT", name: "Português" },
  { key: "RU", name: "русский" }
];
